module.exports = __webpack_public_path__ + "mu.svg?33b7d11749d57a61797d72ab46cc0ed7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/mu.svg
// module id = 1516
// module chunks = 0